import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useIncotermService from '../../../app/services/hooks/useIncotermService';
import { Incoterm } from '../../../app/models/Incoterm';
import IncotermFormContainer from './IncotermFormContainer';

interface Props {
    incotermId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const IncotermEdit = ({ incotermId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingEditIncoterm, editIncoterm, fetchingUpdateIncoterm, updateIncoterm } =
        useIncotermService();

    const [incoterm, setIncoterm] = useState<Incoterm>({ name: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando incoterm...');
        editIncoterm(incotermId, {
            onSuccess: (response: ServiceResponse) => {
                setIncoterm(response.data.incoterm);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando incoterm...');
        updateIncoterm(incotermId, incoterm, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditIncoterm ? (
        <LazyLoading height="300" />
    ) : (
        <IncotermFormContainer
            fetching={fetchingUpdateIncoterm}
            action={update}
            cancel={cancel}
            incoterm={incoterm}
            setIncoterm={setIncoterm}
            errorFields={errorFields}
        />
    );
};

export default IncotermEdit;
